/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';

import SociollaText from '@components/sociolla/SociollaText';
import SociollaCard from '@components/sociolla/SociollaCard';
import NotificationItem from '@/screens/task-notification/components/NotificationItem';

import Colors from '@global/colors';
import { handleTaskNotificationDetail } from '@global/helpers';

function Task({ data, style, navigation }) {
  // const isTask = true;

  const seeAll = () => {
    navigation.navigate('TaskNotificationNavigator', {
      screen: 'TaskNotificationScreen',
      params: {
        task: true,
      },
    });
  };

  const generateStyle = (type) => {
    const dt = { icon: '', color: '' };
    if (type === 'product_display') {
      dt.icon = require('@assets/img/icons/account.svg');
      dt.color = 'rgba(30, 104, 252, 0.08)';
    } else if (type === 'planogram_guideline') {
      dt.icon = require('@assets/img/icons/schedule.svg');
      dt.color = 'rgba(252, 30, 104, 0.08)';
    } else if (type === 'npd') {
      dt.icon = require('@assets/img/icons/schedule.svg');
      dt.color = 'rgba(252, 30, 104, 0.08)';
    } else if (type === 'pending_payment') {
      dt.icon = require('@assets/img/icons/order.svg');
      dt.color = 'rgba(252, 178, 30, 0.08)';
    }
    return dt;
  };

  const newData = data.map((dt) => {
    const newDt = Object.assign({}, dt);
    const gen = generateStyle(dt.type);
    newDt.icon = gen.icon;
    newDt.color = gen.color;
    return newDt;
  });

  const openDetail = (data) => {
    handleTaskNotificationDetail({
      data: data,
      navigation: navigation,
      isTask: true,
    });
    // if (
    //   data.target_type === 'orders' &&
    //   data.target.entity === 'orders' &&
    //   data.target.id
    // ) {
    //   const params = {
    //     id: data.target.id,
    //     isTask,
    //   };
    //   if (data?.object?.orderId) {
    //     params.titleScreen = data.object.orderId;
    //   }
    //   navigation.navigate('SalesOrderNavigator', {
    //     screen: 'SalesOrderDetailScreen',
    //     params: params,
    //   });
    // } else {
    //   navigation.navigate('TaskNotificationNavigator', {
    //     screen: 'TaskNotificationDetailScreen',
    //     params: {
    //       titleScreen: data.title ? data.title : '',
    //       name: data.title ? data.title : '',
    //       id: data._id,
    //       isTask,
    //     },
    //   });
    // }
  };

  return (
    <SociollaCard
      borderColor={Colors.blue2}
      style={style}
      onPress={seeAll}
      header={
        <View style={styles.taskHeader}>
          <SociollaText type="medium" style={{ fontSize: 18 }}>
            Task
          </SociollaText>
          <SociollaText
            style={{ fontSize: 14, color: Colors.blue0 }}
            onPress={seeAll}>
            see all
          </SociollaText>
        </View>
      }>
      {!(newData && newData.length) ? (
        <View style={{ padding: 15 }}>
          <SociollaText>No data found</SociollaText>
        </View>
      ) : (
        <ScrollView>
          <View style={{ marginBottom: 10 }} />
          {newData.slice(0, 3).map((x, i) => (
            <NotificationItem
              key={i}
              item={x}
              isList
              isDashboard={true}
              onPress={() => openDetail(x)}
            />
          ))}
        </ScrollView>
      )}
    </SociollaCard>
  );
}

const styles = StyleSheet.create({
  taskHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
});

export default Task;
